export const DEFAUL_MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
export const DEFAUL_MAX_FILES_COUNT = 10;

export const ERROR_MESSAGE_PREFIX = 'Failed to upload one or more files';
